(function () {
  'use strict';

  angular.module('app').component('packageCostsAndPrices', packageCostsAndPrices());

  function packageCostsAndPrices() {
    return {
      bindings: {
        package: '<',
        onCostsAndPricesSaved: '&',
        defaultLanguage: '<',
        userLanguageCode: '<',
      },
      controller: PackageCostsAndPricesComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/packages/components/package-costs-and-prices/package-costs-and-prices.component.html',
    };
  }

  function PackageCostsAndPricesComponent() {
    const vm = this;

    vm.$onInit = function () {
      vm.showCosts = true;
      vm.showPrices = true;

      // Initilizers
      vm.zonesByProduct = [];
    };

    vm.onSeasonSelected = function (season) {
      vm.seasonSelected = season;
    };

    vm.onProductCostsAndPricesSaved = function (associated_providers) {
      vm.onCostsAndPricesSaved({ associated_providers: associated_providers });
    };
  }
})();
